import { api } from '@services';

const deleteDocument = async (id: string): Promise<void> => {
  await api.delete<void>(`/documents/${id}`);
};

export { deleteDocument };
